// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gWf80FmcNO65Hd {
  display: flex;
  height: 100vh;
}
.hIlbOkoIOozQ23 {
  display: flex;
  position: relative;
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
  height: 100vh;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding: var(--ds-space-0, 0) 112px 56px 56px;
  overflow-y: scroll;
}
.FqekCygtpcG0_m {
  position: fixed;
  z-index: 10;
  top: var(--ds-space-200, 16px);
  right: var(--ds-space-400, 32px);
  padding: var(--ds-space-150, 10px);
  border-radius: var(--ds-border-radius-circle, 50%);
  cursor: pointer;
}
.gWf80FmcNO65Hd.wrgfaPbdOynRq4,
.gWf80FmcNO65Hd.wrgfaPbdOynRq4 .hIlbOkoIOozQ23,
.gWf80FmcNO65Hd.wrgfaPbdOynRq4 .cjJwvF1i9plInl {
  height: calc(100vh - 60px);
}
.gWf80FmcNO65Hd.wrgfaPbdOynRq4 .FqekCygtpcG0_m {
  top: 76px;
}
`, ""]);
// Exports
export var page = `gWf80FmcNO65Hd`;
export var main = `hIlbOkoIOozQ23`;
export var closeButton = `FqekCygtpcG0_m`;
export var anonymous = `wrgfaPbdOynRq4`;
export var sidebar = `cjJwvF1i9plInl`;
export default ___CSS_LOADER_EXPORT___;
